/* "Nirvik Ready for communities and meetups" (/guides/communities): its own opening, ideas and playbook around the shared chapters. */
import why from './why.md?raw';
import ideas from './ideas.md?raw';
import playbook from './playbook.md?raw';
import { audienceGuide } from '../audience';

export const communitiesGuide = audienceGuide({
  audience: 'communities',
  title: 'Nirvik Ready for communities and meetups',
  subtitle:
    'How meetups, user groups and clubs run challenges, events and learning paths their members love, for free.',
  reviewed: '2026-10-25',
  why: {
    title: 'Why Nirvik Ready for communities and meetups',
    summary: 'Members, builders, newcomers and organizers',
    markdown: why,
  },
  ideas: { summary: 'Meetup challenges, certificates, chapters and hackathons', markdown: ideas },
  playbook: { summary: 'Your first three meetups', markdown: playbook },
});
